"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_FAMILY_INFO_GROUPS = exports.CHILD_AND_CHILD_TEEN_DEFAULT_QUESTION_GROUPS = exports.CHILD_ADULT_DEFAULT_QUESTION_GROUPS = exports.PARTNER_DEFAULT_QUESTION_GROUPS = exports.APPLICANT_DEFAULT_QUESTION_GROUPS = void 0;
const question_groups_1 = require("../groups/question-groups");
// Default Forms
exports.APPLICANT_DEFAULT_QUESTION_GROUPS = [
    question_groups_1.QuestionGroup["TALENT_PERSONAL_DETAILS"],
    question_groups_1.QuestionGroup["APPLICANT_STUDY_CONTACT_INFORMATION"],
    question_groups_1.QuestionGroup["APPLICANT_STUDY_PRIMARY_ADDRESS"],
    question_groups_1.QuestionGroup["TALENT_CURRENT_COUNTRY_RESIDENCE"],
    question_groups_1.QuestionGroup["TALENT_PREVIOUS_COUNTRY_RESIDENCE"],
    question_groups_1.QuestionGroup["TALENT_MARITAL_STATUS"],
    question_groups_1.QuestionGroup["TALENT_LANGUAGES"],
    question_groups_1.QuestionGroup["TALENT_PASSPORT"],
    question_groups_1.QuestionGroup["TALENT_NATIONAL_IDENTITY"],
    question_groups_1.QuestionGroup["TALENT_US_PR"],
    question_groups_1.QuestionGroup["TALENT_EMPLOYMENT"],
    question_groups_1.QuestionGroup["TALENT_EDUCATION"],
    question_groups_1.QuestionGroup["APPLICANT_BACKGROUND_INFORMATION"],
    question_groups_1.QuestionGroup["TALENT_FAMILY_INFORMATION_APPLICANT"],
];
exports.PARTNER_DEFAULT_QUESTION_GROUPS = [
    question_groups_1.QuestionGroup["TALENT_PERSONAL_DETAILS"],
    question_groups_1.QuestionGroup["TALENT_OTHER_CONTACT_INFORMATION"],
    question_groups_1.QuestionGroup["TALENT_CURRENT_COUNTRY_RESIDENCE"],
    question_groups_1.QuestionGroup["TALENT_PREVIOUS_COUNTRY_RESIDENCE"],
    question_groups_1.QuestionGroup["TALENT_MARITAL_STATUS"],
    question_groups_1.QuestionGroup["TALENT_LANGUAGES"],
    question_groups_1.QuestionGroup["TALENT_PASSPORT"],
    question_groups_1.QuestionGroup["TALENT_NATIONAL_IDENTITY"],
    question_groups_1.QuestionGroup["TALENT_US_PR"],
    question_groups_1.QuestionGroup["TALENT_EDUCATION"],
    question_groups_1.QuestionGroup["TALENT_EMPLOYMENT"],
    question_groups_1.QuestionGroup["APPLICANT_BACKGROUND_INFORMATION"],
    question_groups_1.QuestionGroup["TALENT_FAMILY_INFORMATION_PARTNER"],
];
exports.CHILD_ADULT_DEFAULT_QUESTION_GROUPS = [
    question_groups_1.QuestionGroup["TALENT_PERSONAL_DETAILS"],
    question_groups_1.QuestionGroup["TALENT_OTHER_CONTACT_INFORMATION"],
    question_groups_1.QuestionGroup["TALENT_CURRENT_COUNTRY_RESIDENCE"],
    question_groups_1.QuestionGroup["TALENT_PREVIOUS_COUNTRY_RESIDENCE"],
    question_groups_1.QuestionGroup["TALENT_MARITAL_STATUS"],
    question_groups_1.QuestionGroup["TALENT_LANGUAGES"],
    question_groups_1.QuestionGroup["TALENT_PASSPORT"],
    question_groups_1.QuestionGroup["TALENT_NATIONAL_IDENTITY"],
    question_groups_1.QuestionGroup["TALENT_US_PR"],
    question_groups_1.QuestionGroup["TALENT_EDUCATION"],
    question_groups_1.QuestionGroup["TALENT_EMPLOYMENT"],
    question_groups_1.QuestionGroup["APPLICANT_BACKGROUND_INFORMATION"],
    question_groups_1.QuestionGroup["TALENT_FAMILY_INFORMATION_CHILD_ADULT"],
];
exports.CHILD_AND_CHILD_TEEN_DEFAULT_QUESTION_GROUPS = [
    question_groups_1.QuestionGroup["TALENT_PERSONAL_DETAILS"],
    question_groups_1.QuestionGroup["TALENT_CHILD_AND_TEEN_CONTACT_INFORMATION"],
    question_groups_1.QuestionGroup["TALENT_CURRENT_COUNTRY_RESIDENCE"],
    question_groups_1.QuestionGroup["TALENT_PREVIOUS_COUNTRY_RESIDENCE"],
    question_groups_1.QuestionGroup["TALENT_LANGUAGES"],
    question_groups_1.QuestionGroup["TALENT_PASSPORT"],
    question_groups_1.QuestionGroup["TALENT_NATIONAL_IDENTITY"],
    question_groups_1.QuestionGroup["TALENT_US_PR"],
    question_groups_1.QuestionGroup["TALENT_BACKGROUND_INFORMATION"],
];
// Other
exports.ALL_FAMILY_INFO_GROUPS = [
    "TALENT_FAMILY_INFORMATION_APPLICANT",
    "TALENT_FAMILY_INFORMATION_PARTNER",
    "TALENT_FAMILY_INFORMATION_CHILD_ADULT",
];
